import React, { memo } from 'react'
import { Box, Card, Divider, Skeleton, Stack } from '@mui/material'

const SkeletonLoading = ({ skipTitle = false }) => {
  return Array.from(new Array(4)).map((_, index) => (
    <Card key={index} sx={{ width: 1 }}>
      <Box sx={{ px: 1, pt: 1 }}>
        <Skeleton
          variant='rectangular'
          width='100%'
          height='100%'
          sx={{ borderRadius: 1.5, aspectRatio: '1/1' }}
        />
      </Box>

      {!skipTitle && (
        <Box
          sx={{
            px: 2,
            py: 2.5,
            minWidth: 0,
            display: 'flex',
            flex: '1 1 auto',
            flexDirection: 'column'
          }}
        >
          <Stack
            direction='row'
            spacing={1}
            alignItems='center'
            sx={{ mb: 0.5 }}
          >
            <Skeleton variant='circular' width={24} height={24} />
            <Skeleton variant='text' width='100%' height={20} />
          </Stack>
        </Box>
      )}
      <Divider sx={{ borderStyle: 'dashed' }} />
      <Box
        sx={{
          px: 2,
          py: 2.5,
          gap: 0.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end'
        }}
      >
        <Skeleton
          variant='rounded'
          width={100}
          height={40}
          sx={{ borderRadius: 1.5 }}
        />
      </Box>
    </Card>
  ))
}

export default memo(SkeletonLoading)
